<template>
    <nav class="navbar horizontal-full-width-layout-navbar fixed-top navbar-expand-lg">
        <div class="navbar-top">
            <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-start">
                <a class="navbar-brand brand-logo" href="/"></a>
                <router-link class="navbar-brand brand-logo" to="/dashboard">
                    <img src="../assets/boflogo.png" alt="logo">
                </router-link>
            </div>
            <div class="navbar-menu-wrapper d-flex flex-grow">
                <ul class="navbar-nav navbar-nav-right collapse navbar-collapse" id="horizontal-top-example">


                </ul>
                <ul class="navbar-nav navbar-nav-left">

                    <li class="nav-item nav-profile dropdown">
                        <a class="nav-link dropdown-toggle" id="profileDropdown" href="#" data-toggle="dropdown"
                           aria-expanded="false">
                            <div class="nav-profile-img">
                                <img src="https://source.unsplash.com/random/200x200" alt="image">
                                <span class="availability-status online"></span>
                            </div>
                            <div class="nav-profile-text">
                                <p class="mb-1 text-black">{{getEmail}}</p>
                                <p class="font-weight-light mb-0">Available</p>
                            </div>
                        </a>
                        <div class="dropdown-menu navbar-dropdown" aria-labelledby="profileDropdown">
                            <a class="dropdown-item" href="#">
                                <i class="mdi mdi-cached mr-2 text-success"></i> Activity Log </a>
                            <div class="dropdown-divider"></div>
                            <router-link :to="{name:'logout'}" class="dropdown-item">
                                <i class="mdi mdi-logout mr-2 text-primary"></i> Signout
                            </router-link>

                        </div>
                    </li>
                </ul>

                <button class="navbar-toggler navbar-toggler-right d-lg-none align-self-center ml-auto" type="button"
                        data-toggle="collapse" data-target="#horizontal-top-example">
                    <span class="mdi mdi-menu"></span>
                </button>
            </div>
        </div>

    </nav>
</template>

<script>
    export default {
        name: "HeaderNav",
        computed: {
            getEmail() {
                return this.$store.getters.GET_USER ? this.$store.getters.GET_USER.email : ""
            }
        }
    }
</script>

<style scoped>
    .brand-logo img {
        height: 2em;
        width: auto!important;
    }
</style>
